import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_URL}/api/donations`; // adjust if deployed

// Get donation data from backend
export async function getDonationDataApi(apikey) {
  try {
    const res = await axios.get(`${API_BASE}/data/${apikey}`);
    return res.data;
  } catch (err) {
    console.error("getDonationDataApi error:", err.response?.data || err.message);
    throw err;
  }
}
